import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { ReadableApi } from "./readable-api.service";
import { RestHttp } from "./rest-http.service";

export abstract class WritableApi<
  M extends { id?: string | number }
> extends ReadableApi<M> {
  constructor(protected rest: RestHttp) {
    super(rest);
  }

  update(model: M): Observable<M> {
    if (model.id == null) {
      throw new Error(`Missing id on model, cannot make an update request`);
    }
    return this.rest
      .put(
        [this.modelPath, model.id],
        this.modelToJson(model),
        undefined,
        "json",
        this.headers
      )
      .pipe(map((res) => this.jsonToModel(this.getModelFromResponse(res))));
  }

  create(model: M): Observable<M> {
    return this.rest
      .post(
        this.modelPath,
        this.modelToJson(model),
        undefined,
        "json",
        this.headers
      )
      .pipe(map((res) => this.jsonToModel(this.getModelFromResponse(res))));
  }

  protected modelToJson(model: M): object {
    return model;
  }
}
